import { apiCall } from "../../services/api-service";

export const getStopsListApi = async (params) => {
  try {
    const response = await apiCall("GET", "stops", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitStopsAPI = async (body) => {
  try {
    const response = await apiCall("POST", "stops", body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateStopsAPI = async (id, body) => {
  try {
    const response = await apiCall("PUT", `stops/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getStopsEditApi = async (id) => {
  try {
    const response = await apiCall("GET", `stops/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteStopsApi = async (id) => {
  try {
    const response = await apiCall("DELETE", `stops/delete/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const bulkDeleteStopsApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    const response = await apiCall("DELETE", "stops/bulkdelete", data);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getStopsViewApi = async (id) => {
  try {
    const response = await apiCall("GET", `stops/view/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getActualWorkflowApi = async (id) => {
  try {
    const response = await apiCall("GET", `stops/workflow/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getEstimateWorkflowApi = async (id) => {
  try {
    const response = await apiCall("GET", `stops/est_workflow/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const uploadStopsExcelApi = async (payload) => {
  try {
    const response = await apiCall("POST", "stop_upload", payload);
    return response;
  } catch (err) {
    console.error("Error uploading Excel file:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const uploadTripExcelApi = async (payload) => {
  try {
    const response = await apiCall("POST", "trip_upload", payload);
    return response;
  } catch (err) {
    console.error("Error uploading Excel file:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download Stop Template
export const downloadStopTemplateApi = async () => {
  try {
    const response = await apiCall("POST", "template_download", { type: "stop" });
    return response;
  } catch (err) {
    console.error("Error downloading template:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getCustomerAddressApi = async (id) => {
  try {
    const response = await apiCall("GET", `customer/address/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

// Download base64 file utility
export const downloadBase64File = (base64String, fileName) => {
  try {
    const base64Data = base64String.replace(/^data:.*,/, "");
    const binary = atob(base64Data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
